var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M10 0C4.48622 0 0 4.48622 0 10C0 15.5138 4.48622 20 10 20C15.5138 20 20 15.5138 20 10C20 4.48622 15.5138 0 10 0Z",
          fill: "#333333",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M15.7071 5.70711C16.0976 6.09763 16.0976 6.7308 15.7071 7.12132L9.12132 13.7071C8.7308 14.0976 8.09763 14.0976 7.70711 13.7071C7.63505 13.635 7.57628 13.5547 7.53082 13.4692C7.44528 13.4237 7.36496 13.365 7.29289 13.2929L4.70711 10.7071C4.31658 10.3166 4.31658 9.68342 4.70711 9.29289C5.09763 8.90237 5.7308 8.90237 6.12132 9.29289L8.41422 11.5858L14.2929 5.70711C14.6834 5.31658 15.3166 5.31658 15.7071 5.70711Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }